import React, { useMemo } from 'react';
type QrCodeProps = {
  size?: number;
  color?: string;
};
const GRID = 25;
const FINDERS: Array<[number, number]> = [[0, 0], [GRID - 7, 0], [0, GRID - 7]];
export function QrCode({
  size = 160,
  color = '#0B2A20'
}: QrCodeProps) {
  const cells = useMemo(() => buildCells(), []);
  const unit = size / GRID;
  return <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label="QR code to download the AVEGA app" shapeRendering="crispEdges" data-id="element-230" data-mp="1c3q3e6lf4s5u">
      {cells.map(([x, y]) => <rect key={`${x}-${y}`} x={x * unit} y={y * unit} width={unit} height={unit} fill={color} data-id="element-231" data-mp="1zulzvh0tkbjf" />)}
    </svg>;
}
function buildCells() {
  const result: Array<[number, number]> = [];
  for (let y = 0; y < GRID; y++) {
    for (let x = 0; x < GRID; x++) {
      const finder = finderAt(x, y);
      if (finder !== null) {
        if (finder) result.push([x, y]);
        continue;
      }
      if (nearFinder(x, y)) continue;
      const hash = Math.abs(Math.imul(x + 11, 73856093) ^ Math.imul(y + 7, 19349663) ^ 0x5bd1e995);
      if (hash % 7 < 3) result.push([x, y]);
    }
  }
  return result;
}
function finderAt(x: number, y: number): boolean | null {
  for (const [ox, oy] of FINDERS) {
    const lx = x - ox;
    const ly = y - oy;
    if (lx >= 0 && lx < 7 && ly >= 0 && ly < 7) {
      return lx === 0 || lx === 6 || ly === 0 || ly === 6 || lx >= 2 && lx <= 4 && ly >= 2 && ly <= 4;
    }
  }
  return null;
}
function nearFinder(x: number, y: number) {
  return FINDERS.some(([ox, oy]) => x >= ox - 1 && x <= ox + 7 && y >= oy - 1 && y <= oy + 7);
}